import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Checkbox, type CheckboxProps, type CheckedState, Fieldset, Label, Theme, XStack } from "tamagui";
import { Check } from "@tamagui/lucide-icons";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
export const BooleanCheckboxField = (props: Pick<CheckboxProps, "size" | "native">) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<CheckedState>();
  const {
    label,
    isOptional
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const id = useId();
  const inputId = `${id}_boolean_checkbox_input`;
  const disabled = isSubmitting;
  return <Theme name={error ? "red_alt2" : "granted"} forceClassName data-sentry-element="Theme" data-sentry-component="BooleanCheckboxField" data-sentry-source-file="BooleanCheckboxField.tsx">
      <Fieldset data-sentry-element="Fieldset" data-sentry-source-file="BooleanCheckboxField.tsx">
        <XStack gap="$4" data-sentry-element="XStack" data-sentry-source-file="BooleanCheckboxField.tsx">
          {label ? <Label htmlFor={inputId}>
              {label}
              {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
            </Label> : null}
          <Checkbox disabled={disabled} native checked={field.value} onCheckedChange={checked => field.onChange(checked)} ref={field.ref} id={inputId} {...props} data-sentry-element="Checkbox" data-sentry-source-file="BooleanCheckboxField.tsx">
            <Checkbox.Indicator data-sentry-element="Checkbox.Indicator" data-sentry-source-file="BooleanCheckboxField.tsx">
              <Check data-sentry-element="Check" data-sentry-source-file="BooleanCheckboxField.tsx" />
            </Checkbox.Indicator>
          </Checkbox>
        </XStack>
        <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="BooleanCheckboxField.tsx" />
      </Fieldset>
    </Theme>;
};